import React from "react";
import { object, number } from "prop-types";
// import { useSelector } from "react-redux";
// import get from "lodash/get";
// import { WithLazy, ResponsiveImage, StoryElement } from "@quintype/components";

import StoryHeader from "../story-header";
import StoryElements from "../story-elements";
import StorySideBar from "../story-sidebar";

import "./text-story.m.css";

import StorySeparator from "../../atoms/story-separator";

const TextStoryTemplate = ({ story, index }) => {
  const isMovieReview = story["story-template"] === "movie-review";
  const isGadgetReview = story["story-template"] === "gadget-review";
  const isSponsoredStory = story["story-template"] === "sponsored";
  const isFactCheck = story["story-template"] === "fact-check";
  const isSubhashita = story["story-template"] === "subhashita";

  return (
    <>
      {index > 0 && <StorySeparator />}
      <div styleName="story-wrapper">
        <div className="story-section">
          <div>
            <StoryHeader story={story} isSponsoredStory={isSponsoredStory} />
            <StoryElements
              story={story}
              cards={isSubhashita ? story.cards.slice(1) : story.cards}
              index={index}
              isFactCheck={isFactCheck}
              isMovieReview={isMovieReview}
              isGadgetReview={isGadgetReview}
              isSponsoredStory={isSponsoredStory}
            />
          </div>
        </div>
        <div className="side-story-section">
          <StorySideBar index={index} story={story} />
        </div>
        {/* <div className="more-news-section">
          <MoreNews story={story} />
        </div> */}
      </div>
    </>
  );
};

TextStoryTemplate.propTypes = {
  story: object,
  index: number
};

const TextStory = ({ story, index }) => {
  return <TextStoryTemplate story={story} index={index} />;
};

TextStory.propTypes = {
  story: object,
  index: number
};

export default TextStory;
